// extracted by mini-css-extract-plugin
export default {"container":"Dashboard-module--container--gLA7A","cards":"Dashboard-module--cards--0quCC","cardsmobile":"Dashboard-module--cardsmobile--nAnWD"};